import { useCallback, useState } from 'react';

/**
 * Bill Memory (Fix plan, Fix 13 row 7): the vendor last picked on the Stock In form (the dropdown or a vendor
 * button — a certain vendor), held above the form so the scanner can send it with the next scan (design P3)
 * and the form remounted with the scan's rows keeps it. The form reports every pick and every clear through
 * onPicked (the vendor row it picked, or null). → { picked: vendor row | null, onPicked, scannerVendorId }
 */
export function useBmPickedVendor() {
  const [picked, setPicked] = useState(null);
  const onPicked = useCallback((v) => {
    setPicked(v && Number(v.vendor_id) > 0 ? { ...v, vendor_id: Number(v.vendor_id), name: v.name || '' } : null);
  }, []);
  return { picked, onPicked, scannerVendorId: picked ? picked.vendor_id : null };
}
